import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Checkbox,
  FormControlLabel,
  TextField,
  Divider,
  Container,
  Chip,
} from "@mui/material";
import { products } from "./data/products";

// import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";

function App() {
  // 사용자 수 기본값을 10으로 설정
  const initialUsers = Object.fromEntries(products.map((p) => [p.id, 10]));
  const [users, setUsers] = useState(initialUsers);
  const [selectedOptions, setSelectedOptions] = useState({});

  const handleUserChange = (id, value) => {
    setUsers((prev) => ({ ...prev, [id]: parseInt(value) || 0 }));
  };

  const handleOptionToggle = (productId, optionName) => {
    setSelectedOptions((prev) => {
      const prevOptions = prev[productId] || [];
      const newOptions = prevOptions.includes(optionName)
        ? prevOptions.filter((o) => o !== optionName)
        : [...prevOptions, optionName];
      return { ...prev, [productId]: newOptions };
    });
  };

  const calculateTotal = (product) => {
    const userCount = users[product.id] || 0;
    const selected = selectedOptions[product.id] || [];
    const optionSum = product.options
      .filter((opt) => selected.includes(opt.name) && opt.price)
      .reduce((sum, opt) => sum + opt.price, 0);
    return userCount * (product.basePrice + optionSum);
  };

  const [focusedCard, setFocusedCard] = useState(null);
  //const totalAll = products.reduce((sum, p) => sum + calculateTotal(p), 0);

  return (
    <Container   
      maxWidth={false}
      sx={{
        maxWidth: "1400px", // 원하는 최대 폭
        width: "100%",
        px: 6, // 좌우 패딩
        py: 6, // 상하 패딩
        margin: "0 auto", // 가운데 정렬
      }}>
      <Typography 
        variant="h4" 
        fontWeight="700" 
        textAlign="center" 
        gutterBottom
        sx={{
          fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" },
          wordBreak: "keep-all"
        }}  
      >
        NOPSpro 그룹웨어 견적 계산기
      </Typography>
      {/* <Typography
        variant="subtitle1"
        color="text.secondary"
        textAlign="center"
        mb={1}
      >
        제품별 기능과 옵션을 비교하고 인원 수를 입력해 월 요금을 계산하세요.
      </Typography> */}

      <Typography
        variant="body2"
        color="text.secondary"
        textAlign="center"
        mb={3}
      >
        ※ 셋업 & 인증비: 100,000원 (부가세 별도)
      </Typography>

      <Box
        display="grid"
        gridTemplateColumns="repeat(4, 1fr)" // 한 줄에 4개 카드
        gap={3}
        sx={{
          "@media(max-width:1200px)": { gridTemplateColumns: "repeat(3, 1fr)" },
          "@media(max-width:900px)": { gridTemplateColumns: "repeat(2, 1fr)" },
          "@media(max-width:600px)": { gridTemplateColumns: "1fr" },
        }}
      >
        {products.map((product, cardIndex) => {
          const total = calculateTotal(product);
          const annual = total * 11;

          return (
            <Card
              onFocus={() => setFocusedCard(product.id)}
              onBlur={() => setFocusedCard(null)}
              key={product.id}
              sx={(theme) => ({
                borderRadius: 3,
                boxShadow: 4,
                transition: "transform 0.2s",
                "&:hover": { transform: "translateY(-4px)" },
                "&:focus-within": {
                  border: `2px solid ${theme.palette.primary.main}90`, // primary 색상 적용
                  boxShadow: `0 0 10px ${theme.palette.primary.main}30`, // 55 = alpha
                },
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%", // 카드 높이 동일
              })}
            >
              <CardContent 
              sx={{ 
                  display: "flex",
                  flexDirection: "column",
                  height: "100%", // 카드 높이 동일
                }}
              >
                
                <Box sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" color="primary" gutterBottom>
                    {product.name}
                  </Typography>
                  <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                    ₩{product.basePrice.toLocaleString()} / 사용자(USER)
                  </Typography>

                  <Divider sx={{ my: 2 }} />

                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    gutterBottom
                  >
                    {/* ✅ 카드 3,4번째만 (모바일 별도) 문구 */}
                    {cardIndex >= 2 ? "기본 기능 (모바일 별도)" : "기본 기능 (모바일 포함)"}
                  </Typography>
                  <Box sx={{ 
                    minHeight:160,
                    display: "flex", 
                    flexWrap: "wrap", 
                    gap: 1, 
                    mt:1,
                    alignItems: "flex-start",
                    alignContent: "flex-start"
                  }}>
                    {product.baseFeatures.map((feature, index) => (
                      <Chip
                        key={index}
                        label={feature}
                        size="small"
                        color={cardIndex > 0 && index === 0 ? "secondary" : "primary"} // ✅ 첫번째 칩만 색 다르게
                        variant="outlined"
                        sx={{ 
                          minWidth: 87,
                          fontSize: 12
                         }}
                      />
                    ))}
                  </Box>
                 

                  <Box mt={2}>
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      gutterBottom
                    >
                      옵션 선택
                    </Typography>
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                      {product.options.map((opt, i) => {
                        const selected = (selectedOptions[product.id] || []).includes(opt.name);
                        return (
                          <Chip
                            key={i}
                            label={opt.price ? `${opt.name} (+₩${opt.price.toLocaleString()})` : opt.name}
                            variant={selected ? "filled" : "outlined"}
                            color={selected ? "primary" : "default"}
                            size="small"
                            onClick={() => { 
                              if (!opt.price) return; // 가격 없으면 클릭 무시
                              handleOptionToggle(product.id, opt.name)
                            }}
                            sx={{
                              minWidth: 135, 
                              cursor: opt.price ? "pointer" : "not-allowed", opacity: opt.price ? 1 : 0.5 
                            }}
                          />
                        );
                      })}
                    </Box>
                    
                  </Box>
                </Box>

                <Box mt={2}>
                  <TextField
                    label="사용자 수"
                    type="number"
                    size="small"
                    variant="outlined"
                    value={users[product.id] || 0}
                    onChange={(e) => handleUserChange(product.id, e.target.value)}
                    sx={{ width: 120, mb: 1 }}
                  />

                  {/* 월 요금 */}
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="body1" fontWeight="bold">
                      월 요금
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color={focusedCard === product.id ? "primary" : "text.primary"}
                    >
                      ₩{total.toLocaleString()}
                    </Typography>
                  </Box>

                  {/* 년 요금 */}
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="body2" color="text.secondary">
                      년 요금
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      ₩{annual.toLocaleString()}
                    </Typography>
                  </Box>

                  {/* 유저당 단가 */}
                  <Box display="flex" justifyContent="space-between">
                    <Typography variant="body2" color="text.secondary">
                      유저당 단가
                    </Typography>
                    <Typography
                      variant="body2"
                      fontWeight="bold"
                      color={
                        (selectedOptions[product.id] || []).length > 0
                          ? "secondary"
                          : "text.secondary"
                      }
                    >
                      ₩
                      {users[product.id]
                        ? Math.round(total / users[product.id]).toLocaleString()
                        : 0}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Box>

      
    </Container>
  );
}

export default App;
